jQuery(document).ready(function($) {
  const $menu = $('.nohem-menu-mobile');
  $menu.on('click', '.menu-horizon-list a.relative, .menu-horizon-list a.relative ~ .toggle-nohem-menu-mobile', (e) => this.__itemLevel1_click(e));

  this.__itemLevel1_click = function(event){
    event.preventDefault();
    event.stopImmediatePropagation();

    const $item = $(event.currentTarget).parents('.menu-horizon-list');
    if($item.hasClass('active')){
      $item.removeClass('active');
    }else{
      $menu.find('.menu-horizon-list.active').removeClass('active');
      $item.addClass('active');
    }
  }
});
